export default __webpack_public_path__ + "static/media/NotoSans-BoldItalic.d0737322.ttf";